import { CommonRecipe, CommonRecipeTag } from "@/types/commonRecipe";
import { RecipeFoods } from "@/types/pantry";
import NativeClient from "@/client/native-client";

/** お気に入り関連 */
export interface RootState {
  version: string;
}

export interface MypageState {
  addRecipeResult: MypageOperationResult | null;
  deleteRecipeResult: MypageOperationResult | null;
  recentFavoriteRecipeList: MypageRecipeClips | null;
  favoriteRecipeList: MypageRecipeClips | null;
  folderList: MypageFolders | null;
  folderRecipeList: MypageFolderClips | null;
  registFolderResult: MypageFolderOperationResult | null;
  renameFolderResult: MypageFolderOperationResult | null;
  deleteFolderResult: MypageFolderOperationResult | null;
  addFolderRecipeResult: MypageOperationResult | null;
  deleteFolderRecipeResult: MypageOperationResult | null;
  folderMoveResult: MypageOperationResult | null;
  folderName: string | null;
  selectedTab: number;
  favoriteFoodList: RecipeFoods | null;
  inquiryStatus: MypageInquiryStatus | null;
  foodsRanking: MypageFoodsRanking | null;
  userRanking: MypageUserRanking | null;
  topHistoryRecipe: MypageHistoryRecipes | null;
  historyRecipe: MypageHistoryRecipes | null;
  monthlyUsedRanking: Array<MypageStoreUserRanking> | null;
  personalMonthlyUsedFoodsRanking: Array<MypageStoreFoodsRanking> | null;
  personalMonthlyDisposedFoodsRanking: Array<MypageStoreFoodsRanking> | null;
  nationwideMonthlyUsedFoodsRanking: Array<MypageStoreFoodsRanking> | null;
  nationwideMonthlyDisposedFoodsRanking: Array<MypageStoreFoodsRanking> | null;
  selectedMonthIndex: number | null;
}

/** お気に入り関連のComponent間インターフェース定義 */

/*********************
 * APIのレスポンス定義
 *********************/
/**
 * API お気に入りフォルダ内のレシピ情報 付属品情報
 */
export class MypageRecipeAttachment {
  id: string;
  description: string;

  constructor() {
    this.id = "";
    this.description = "";
  }
}
/**
 * API お気に入りフォルダ内のレシピ情報 作成者情報
 */
export class MypageRecipeMenuAuthor {
  name: string;
  forDisplay: string;

  constructor() {
    this.name = "";
    this.forDisplay = "";
  }
}
/**
 * API お気に入りフォルダ内のレシピ情報の栄養情報
 */
export class MypageRecipeNutrition {
  note: string;
  calories: number;
  salt: number;
  carbohydrate: number;
  lipid: number;
  protein: number;

  constructor() {
    this.note = "";
    this.calories = 0;
    this.salt = 0;
    this.carbohydrate = 0;
    this.lipid = 0;
    this.protein = 0;
  }
}
/**
 * API お気に入りフォルダ内のレシピ情報のタグ情報
 */
export interface MypageRecipeTag {
  id: number;
  name: string;
}

/**
 * API お気に入りフォルダ一覧の要素定義
 */
interface MypageFolder {
  favoriteFolderId: number;
  name: string;
  imageUrl: string;
  clipCount: number;
}

/**
 * API お気に入りフォルダ一覧取得のレスポンス定義
 */
export class MypageFolders {
  folders: Array<MypageFolder>;
  folderCount: number;

  constructor() {
    this.folders = [];
    this.folderCount = 0;
  }
}

/**
 * API レシピンのタイトル・ラベル
 */
export class MypageRecipeTitleLabel {
  description: string;
  fgColor: string;
  bgColor: string;
  constructor() {
    this.description = "";
    this.fgColor = "";
    this.bgColor = "";
  }
}

/**
 * API レシピの画像
 */
export class MypageRecipeImage {
  original: string;
  main: string;
  thumb: string;
  constructor() {
    this.original = "";
    this.main = "";
    this.thumb = "";
  }
}

/**
 * API レシピのリアクション
 */
export class MypageRecipeReaction {
  done: boolean;
  count: number;
  constructor() {
    this.done = false;
    this.count = 0;
  }
}

/**
 * API レシピのリアクション
 */
export class MypageRecipeReactions {
  like: MypageRecipeReaction;
  favorite: MypageRecipeReaction;
  myComment: MypageRecipeReaction;
  constructor() {
    this.like = new MypageRecipeReaction();
    this.favorite = new MypageRecipeReaction();
    this.myComment = new MypageRecipeReaction();
  }
}

/**
 * API お気に入りフォルダ登録／変更のレスポンス定義
 */
export class MypageFolderOperationResult {
  favoriteFolderId: number;
  name: string;
  created: string;

  constructor() {
    this.favoriteFolderId = 0;
    this.name = "";
    this.created = "";
  }
}

/**
 * API お気に入りフォルダ内のレシピ情報 レシピ定義
 */
export class MypageRecipeClip {
  recipeId: number;
  caption: string;
  imageUrl: string;
  moduleType: string;
  nutrition: MypageRecipeNutrition;
  device: string;
  applianceCategoryId: number;
  productId: string;
  attachments: Array<MypageRecipeAttachment> | null;
  isFormal: boolean;
  author: MypageRecipeMenuAuthor;
  numComment: number;
  numGood: number;
  goodStatus: boolean;
  favoriteStatus: boolean;
  commentStatus: boolean;
  dishType: string;
  groupId: number;
  dlMenuId: string;
  type: string;
  tags: Array<MypageRecipeTag>;
  releaseDate: string;
  defaultDlMenuId: number;

  constructor() {
    this.recipeId = 0;
    this.caption = "";
    this.imageUrl = "";
    this.moduleType = "";
    this.nutrition = new MypageRecipeNutrition();
    this.device = "";
    this.applianceCategoryId = 0;
    this.productId = "";
    this.attachments = null;
    this.isFormal = false;
    this.author = new MypageRecipeMenuAuthor();
    this.numComment = 0;
    this.numGood = 0;
    this.goodStatus = false;
    this.favoriteStatus = false;
    this.commentStatus = false;
    this.dishType = "";
    this.groupId = 0;
    this.dlMenuId = "";
    this.type = "";
    this.tags = [];
    this.releaseDate = "";
    this.defaultDlMenuId = 0;
  }
}

/**
 * お気に入りのレシピ取得結果
 */
export class MypageRecipeClips {
  clips: Array<MypageRecipeClip>;
  totalCount: number;
  start: number;
  lastUpdate: string;

  constructor() {
    this.clips = [];
    this.totalCount = 0;
    this.start = 0;
    this.lastUpdate = "";
  }
}

/**
 * API お気に入りフォルダ内のレシピ情報取得のレスポンス
 */
export class MypageFolderClips {
  favoriteFolderId: number;
  name: string;
  imageUrl: string;
  start: number;
  totalCount: number;
  clips: Array<MypageRecipeClip>;
  created: string;
  lastUpdate: string;

  constructor() {
    this.favoriteFolderId = 0;
    this.name = "";
    this.imageUrl = "";
    this.start = 0;
    this.totalCount = 0;
    this.clips = [];
    this.created = "";
    this.lastUpdate = "";
  }
}

/**
 * API お気に入りフォルダ更新レスポンス
 */
export class MypageFolderUpdate {
  favoriteFolderId: number;
  name: string;
  created: string;

  constructor() {
    this.favoriteFolderId = 0;
    this.name = "";
    this.created = "";
  }
}

/**
 * API お気に入りフォルダ・レシピ追加/削除の要素
 */
interface MypageFolderOperationRecipe {
  recipeId: number;
}

/**
 * API お気に入りフォルダ・レシピ追加/削除のレスポンス
 */
export class MypageFolderOperationRecipeList {
  recipes: Array<MypageFolderOperationRecipe>;

  constructor() {
    this.recipes = [];
  }
}

/**
 * API お気に入りフォルダ・レシピ追加定義
 */
export class MypageAddFolderRecipe {
  recipeId: number;
  groupId: number;

  constructor(recipeId: number, groupId: number) {
    this.recipeId = recipeId;
    this.groupId = groupId;
  }
}

/**
 * API お気に入りフォルダ・レシピ削除定義
 */
export class MypageDeleteFolderRecipe {
  recipeId: number;

  constructor(recipeId: number) {
    this.recipeId = recipeId;
  }
}

/**
 * API お気に入りフォルダ・レシピ追加/削除のレスポンス
 */
export class MypageOperationResult {
  status: boolean;

  constructor() {
    this.status = true;
  }
}

/**
 * フォルダ表示定義
 */
export class FolderInfo {
  id: number;
  name: string;
  image: string;
  numberOfItems: number;
  constructor() {
    this.id = 0;
    this.name = "";
    this.image = "";
    this.numberOfItems = 0;
  }
}

// 買い物リストへの食材登録
export class MypageShoppingListRegistListItem {
  foodId: number | null;
  name: string | null;
  constructor(foodId: number | null, name: string | null) {
    this.foodId = foodId;
    this.name = name;
  }
}

// 問診状態
export class MypageInquiryStatus {
  answered: boolean;
  answerDateTime: string;

  constructor() {
    this.answered = false;
    this.answerDateTime = "";
  }
}

// ユーザー食品ランキング
export class MypageFoodsRanking {
  foods: Array<MypageFoodsRankingItem>;
  totalConsumeCount: number;
  calculatedAt: string | null;

  constructor() {
    this.foods = [];
    this.totalConsumeCount = 0;
    this.calculatedAt = "";
  }
}

export class MypageFoodsRankingItem {
  rank: number;
  foodId: number;
  category: string;
  name: string;
  image: string;
  icon: string;
  consumeCount: number;

  constructor() {
    this.rank = 0;
    this.foodId = 0;
    this.category = "";
    this.name = "";
    this.image = "";
    this.icon = "";
    this.consumeCount = 0;
  }
}

// ユーザー食品消費度順位
export class MypageUserRanking {
  rank: number | null;
  feedback: string | null;

  constructor() {
    this.rank = null;
    this.feedback = null;
  }
}

export class MypageHistoryRecipes {
  recipes: Array<MypageHistoryRecipeItem>;
  totalCount: number;
  start: number;

  constructor() {
    this.recipes = [];
    this.totalCount = 0;
    this.start = 0;
  }
}

export interface MypageHistoryRecipeItem {
  recipeId: number;
  groupId: number;
  title: string;
  subTitle: string;
  applianceCategory: string;
  applianceCategoryId: number;
  productId: string;
  attachments: Array<MypageHistoryRecipeAttachment> | null;
  dishType: string;
  nutrition: MypageHistoryRecipeNutrition;
  author: MypageHistoryRecipeMenuAuthor;
  type: string;
  titleLabel: MypageHistoryRecipeTitleLabel;
  images: Array<MypageHistoryRecipeImage>;
  tags: Array<MypageHistoryRecipeTag>;
  defaultDlMenuId: number;
  reactions: MypageHistoryRecipeReactions;
  isNew: boolean;
  releaseDate: string;
}

export interface MypageHistoryRecipeAttachment {
  id: string;
  description: string;
}

export interface MypageHistoryRecipeNutrition {
  note: string;
  calories: number;
  salt: number;
  carbohydrate: number;
  lipid: number;
  protein: number;
}

export interface MypageHistoryRecipeMenuAuthor {
  name: string;
  forDisplay: string;
}

export interface MypageHistoryRecipeTitleLabel {
  description: string;
  fgColor: string;
  bgColor: string;
}

export interface MypageHistoryRecipeImage {
  original: string;
  main: string;
  thumb: string;
}

export interface MypageHistoryRecipeTag {
  id: number;
  name: string;
}

export interface MypageHistoryRecipeReactions {
  like: MypageHistoryRecipeReaction;
  favorite: MypageHistoryRecipeReaction;
  myComment: MypageHistoryRecipeReaction;
}

export interface MypageHistoryRecipeReaction {
  done: boolean;
  count: number;
}

// ダイアログの表示制御
export class MypageDialogInfo {
  kind: number;                   // 各ページで決定すること
  type: number;
  title: string;
  message: string;
  positiveButtonLabel: string;
  negativeButtonLabel: string;
  positiveCallback: (() => void) | null;
  negativeCallback: (() => void) | null;

  constructor() {
    this.kind = 0;
    this.type = 0;
    this.title = "";
    this.message = "";
    this.positiveButtonLabel = "";
    this.negativeButtonLabel = "";
    this.positiveCallback = null;
    this.negativeCallback = null;
  }
}

// // 使い切り食品リストのインターフェース
// export class MypageUsedFoodList {
//   totalFoodsCount: number;
//   foodList: Array<MypageFoodsRankingItem>

//   constructor() {
//     this.totalFoodsCount = 0;
//     this.foodList = [];
//   }
// }

export class MypageStoreUserRanking {
  month: string;
  data: MypageUserRanking | null;

  constructor() {
    this.month = "";
    this.data = null;
  }
}

export class MypageStoreFoodsRanking {
  month: string;
  data: MypageFoodsRanking | null;
  constructor() {
    this.month = "";
    this.data = null;
  }
}

/** スクロールイベントのIF */
export interface HTMLElementEvent<T extends HTMLElement> extends Event {
  target: T;
}

export type HTMLDivElementEvent = HTMLElementEvent<HTMLDivElement>;

